let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lyv3S")).then(() => parcelRequire('1zktf'));